import { Button } from '@material-ui/core';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import './BackNextButton.scss';
import { CircularProgress } from '@material-ui/core';

export default function BackNextButton(props) {

    const { onBack, continueLabel, disabled,isLoading } = props;
    const label = continueLabel || 'NEXT';
    const isDisabled = disabled || false;
    
    return (
        <Row className="pt-5 mb-4 mx-2">
            <Col className="text-left button-back">
                <Button variant="outlined" size="medium" color="primary" onClick={onBack} >BACK</Button>
            </Col>
            <Col className="text-right button-next">
                <Button variant="contained" size="medium" color="primary" type="submit" disabled={isDisabled}>{isLoading ? <CircularProgress size={25} /> : label}</Button>
            </Col>
        </Row>
    )
}


// WEBPACK FOOTER //
// ./src/components/Common/BackNextButton.js